
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 444.822 444.822"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M423.265 178.298c-6.19-7.139-14.229-10.707-24.126-10.707H198.148L281.8 83.937c7.234-7.229 10.848-15.891 10.848-25.981 0-10.085-3.613-18.747-10.848-25.979l-21.413-21.129C253.156 3.619 244.59 0 234.693 0c-10.089 0-18.752 3.615-25.981 10.848L22.848 196.428c-7.043 7.423-10.564 16.084-10.564 25.981 0 10.089 3.521 18.654 10.564 25.693l185.864 186.152c7.422 7.043 16.083 10.567 25.981 10.567 10.085 0 18.65-3.524 25.693-10.567l21.413-21.693c7.234-6.851 10.848-15.42 10.848-25.693 0-10.284-3.613-18.853-10.848-25.7l-83.652-83.939h200.991c9.896 0 17.936-3.569 24.126-10.707 6.184-7.139 9.274-15.749 9.274-25.838v-36.545c.004-10.089-3.09-18.702-9.273-25.841z"}})])
          )
        }
      }
    